import { render, staticRenderFns } from "./UpdateAmazonAssumeRoleCredentialsDialog.vue?vue&type=template&id=baf9cb5e&"
import script from "./UpdateAmazonAssumeRoleCredentialsDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateAmazonAssumeRoleCredentialsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports